import React, { FC } from 'react'
import styled from 'styled-components'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import useStore from 'store'
import { Button, theme } from 'ui'

const Wrap = styled.div`
  background-color: ${theme.color.dialogBackground};
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 1rem;
`

const OpenButton = styled(Button)`
  padding: 16px 32px;
  border-radius: 10px;
  font-size: 18px;
  font-weight: bold;
`

const Message = styled.div`
  color: ${theme.color.darkGray};
  font-size: 16px;
`

// The service desk itself is an external system: the tab is just the way in,
// signing the user in through sso on the way.
const ServiceDesk: FC = () => {
    const { t } = useTranslation('home')
    const { modulesStore, serviceDeskStore, snackBar } = useStore()
    const url = modulesStore.serviceDeskModule?.external_url

    const openServiceDesk = async () => {
        // Opened right on the click: a window opened after the sso round trip
        // counts as a popup and the browser blocks it.
        const win = window.open('', '_blank')
        const redirectUrl = await serviceDeskStore.openSso().catch(() => null)
        if (!redirectUrl) {
            win?.close()
            snackBar.showError(t`serviceDeskOpenFailed`)
            return
        }
        if (win) {
            win.opener = null
            win.location.href = redirectUrl
        } else {
            // The blank tab was blocked too; a new one would be now, after the
            // wait, so the service desk takes over this tab instead.
            window.location.assign(redirectUrl)
        }
    }

    if (!url) {
        return (
            <Wrap>
                <Message>{t`serviceDeskNoUrl`}</Message>
            </Wrap>
        )
    }

    return (
        <Wrap>
            <OpenButton onClick={openServiceDesk} disabled={serviceDeskStore.loading}>
                {t`serviceDeskOpen`}
            </OpenButton>
        </Wrap>
    )
}

export default observer(ServiceDesk)
